const headerCls = "_uihhm6kvdt";
const ribbonCls = "_uihr1pew1uw";
const headingCls = "_uihh1fcg8n3";
const descriptionCls = "_uihdr013eh";
const spanCls = "_uihsdv1cg";

export { descriptionCls, headerCls, headingCls, ribbonCls, spanCls };
import "./header.style.linaria.module.css";
//# sourceMappingURL=header.style.js.map
